import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';

import { Subscription, Observable } from 'rxjs/';
import { AppState } from 'src/app/store/state/app.state';
import { Logout } from 'src/app/store/actions/logout.actions';
import { QuoteDataCaptureService, UtilService, SERVICE_END_POINT } from 'src/app/shared';
import * as loggedInDetailActions from 'src/app/store/actions/loggedin-detail.action'
import * as YourPensionActions from '../../../../store/actions/your-pension.actions';
import { STORE_VAL } from 'src/app/shared/constants/store-val.constant';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class LogoutComponent implements OnInit {
  isUserLogin = false;
  loginDetailsStore: Observable<any[]>;
  loginDetails: any[];
  public CMSData;
  private subscripBeforeLogin: Subscription;
  externalUrl_RetirementProducts: any;
  @Output() continueWithMySession: EventEmitter<any> = new EventEmitter<any>();
 
constructor(private router: Router, private activatedRoute: ActivatedRoute, private store: Store<AppState>,
  private quoteDatacaptureService: QuoteDataCaptureService,  private utilService: UtilService) {
  this.loginDetailsStore = this.store.select(STORE_VAL.loggedin_detail);
    this.loginDetailsStore.subscribe((val) => {
      if (val.length > 0) {
        this.loginDetails = val[0];
        if(this.loginDetails) {
          this.isUserLogin = true;
          this.store.dispatch(new Logout()); 
          this.store.dispatch(new loggedInDetailActions.RemoveLoggedInDetail(0));
        } else {
          this.isUserLogin = false;
        }
      }
    });
}
  ngOnInit() {
    this.GetCMSDataServiceMapper();
    this.subscripBeforeLogin = this.quoteDatacaptureService.subsVar = this.quoteDatacaptureService.invokeLoginFunction.subscribe(() => {
      this.saveAfterLogin();
    });
    this.store.dispatch(new YourPensionActions.RemoveYourPension(0));
  }

  saveAfterLogin() {
    this.utilService.afterSaveSuccesfully()
  }

  logInAgain() {
	if(this.isUserLogin) {
      this.continueWithMySession.emit(true);
      this.quoteDatacaptureService.onLoginClick();
    } else  {
       this.router.navigate(['/home/get-your-online-quote']);
    }
  }
    /** Code block for CMS */
    GetCMSDataServiceMapper() {
      //console.log('changed value = ');
      const URL = SERVICE_END_POINT.higherEnvironment.CMS_LoggedOut;
      this.utilService.getCMSData(URL).subscribe(res => {
        //console.log('2 GetCMSDataService => ', res);
        this.CMSData = res;
        if (this.CMSData) {
          this.externalUrl_RetirementProducts = this.CMSData.externalUrl_RetirementProducts;
          /** In the line below we are over-writing the contentData object values with CMSData object values */
          //console.log('CMSData ', this.CMSData);
        }
      });
    }
    /** End of code block for CMS */
 }
